<div class="container">
  <div *ngIf="showLogin" class="mt-4">
    <div class="d-flex justify-content-between login-component">
      <p class="login-first">
        {{ "loginByEvento" | translate }}
      </p>
      <i (click)="dismiss()" class="fa fa-times" aria-hidden="true"></i>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <div class="py-4">
        <div class="webkit-center">
          <div class="form-group width-adjust">
            <app-evento-input
              label="{{ 'Mobile number' | translate }}"
              [eventoFormControl]="loginForm.get('username')!"
              type="mobile"
              [country]="loginForm.value?.mobileRegionCode"
              requiredMessage="{{ 'Required Field' | translate }}"
              validatePhoneNumberMessage="{{
                'Valid Mobile Number' | translate
              }}"
            ></app-evento-input>
          </div>

          <div class="form-group width-adjust is-havingPasswordIcon">
            <app-evento-input
              label="{{ 'password' | translate }}"
              type="password"
              [eventoFormControl]="loginForm.get('password')!"
              requiredMessage="{{ 'Required Field' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '6' }
              }}"
              placeholder="{{ 'password' | translate }}"
              iconCustom="fa fa-eye-slash form-icon"
            ></app-evento-input>
          </div>
          <div class="forget">
            <a (click)="forgetPassword()" class="forget-link">
              {{ "did you forget your password?" | translate }}
            </a>
          </div>
          <button
            type="submit"
            [disabled]="loginForm.invalid"
            class="btn btn-primary width-adjust login-btn mb-3"
          >
            {{ "login" | translate }}
          </button>

          <p class="no-account">
            {{ "Don't have an account yet?" | translate }}
            <span class="new-account" (click)="signUpshow()">{{
              "Create New Account" | translate
            }}</span>
          </p>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="showSignUpForm" class="mt-4">
    <div class="px-4 d-flex justify-content-between">
      <p class="login-first">
        {{ "Create New Account" | translate }}
      </p>
      <i (click)="dismiss()" class="fa fa-times" aria-hidden="true"></i>
    </div>
    <form [formGroup]="signupForm" (ngSubmit)="signup()">
      <div class="py-4">
        <div class="webkit-center">
          <div class="form-group width-adjust">
            <app-evento-input
              label="{{ 'First Name' | translate }}"
              [eventoFormControl]="signupForm.get('firstName')!"
              type="text"
              requiredMessage="{{ 'Required Field' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '2' }
              }}"
              maxlengthMessage="{{
                'Max Length Field' | translate : { value: '30' }
              }}"
              patternMessage="{{ 'Valid Name' | translate }}"
              placeholder="{{ 'First Name' | translate }}"
              invalidCharsMessage="{{
                'Only Arabic and English letters are allowed' | translate
              }}"
            ></app-evento-input>
          </div>
          <div class="form-group width-adjust">
            <app-evento-input
              label="{{ 'Last Name' | translate }}"
              [eventoFormControl]="signupForm.get('lastName')!"
              type="text"
              requiredMessage="{{ 'Required Field' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '2' }
              }}"
              maxlengthMessage="{{
                'Max Length Field' | translate : { value: '30' }
              }}"
              invalidCharsMessage="{{
                'Only Arabic and English letters are allowed' | translate
              }}"
              patternMessage="{{ 'Valid Name' | translate }}"
              placeholder="{{ 'Last Name' | translate }}"
            >
            </app-evento-input>
          </div>
          <div class="form-group width-adjust">
            <app-evento-input
              label="{{ 'email' | translate }}"
              [eventoFormControl]="signupForm.get('email')!"
              requiredMessage="{{ 'Required Field' | translate }}"
              emailMessage="{{ 'Valid Email Address' | translate }}"
              placeholder="{{ 'email' | translate }}"
            >
            </app-evento-input>
          </div>
          <div class="form-group width-adjust">
            <app-evento-input
              label="{{ 'Mobile number' | translate }}"
              [eventoFormControl]="signupForm.get('mobile')!"
              type="mobile"
              [country]="signupForm.value?.mobileRegionCode"
              requiredMessage="{{ 'Required Field' | translate }}"
              validatePhoneNumberMessage="{{
                'Valid Mobile Number' | translate
              }}"
            ></app-evento-input>
          </div>
          <div class="form-group width-adjust is-havingPasswordIcon">
            <app-evento-input
              label="{{ 'password' | translate }}"
              [eventoFormControl]="signupForm.get('password')!"
              type="password"
              requiredMessage="{{ 'Required Field' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '6' }
              }}"
              placeholder="{{ 'password' | translate }}"
              iconCustom="fa fa-eye-slash form-icon"
            ></app-evento-input>
          </div>
          <div class="form-group width-adjust is-havingPasswordIcon">
            <app-evento-input
              label="{{ 'Confirm Password' | translate }}"
              [eventoFormControl]="signupForm.get('confirmPassword')!"
              type="password"
              requiredMessage="{{ 'Required Field' | translate }}"
              mustMatchMessage="{{ 'Not Matched' | translate }}"
              placeholder="{{ 'Confirm Password' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '6' }
              }}"
              iconCustom="fa fa-eye-slash form-icon"
            ></app-evento-input>
          </div>
          <div class="form-group width-adjust">
            <label class="custom-control custom-checkbox mb-4">
              <input
                type="checkbox"
                class="custom-control-input"
                (change)="toggleAgree($event)"
              />
              <span class="custom-control-label">
                {{ "Agree to the" | translate }}
                <a
                  style="
                    color: #0b2027;
                    text-decoration: none !important;
                    font-weight: bold;
                  "
                  href="#"
                  (click)="
                    $event.preventDefault(); openLinkInNewWindow('/policy')
                  "
                  >{{ "Terms and Conditions" | translate }}</a
                >
              </span>
            </label>
          </div>
          <button
            type="submit"
            [disabled]="!isAgree || !signupForm.valid"
            class="btn btn-primary width-adjust login-btn mb-3"
          >
            {{ "Create New Account" | translate }}
          </button>

          <p class="no-account">
            {{ "already have account" | translate }}
            <span class="new-account" (click)="loginshow()">{{
              "login" | translate
            }}</span>
          </p>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="showOtpForm" class="mt-4">
    <div class="px-4 d-flex justify-content-between">
      <p class="login-first">
        {{ "Enter the verification code" | translate }}
      </p>
      <i (click)="dismiss()" class="fa fa-times" aria-hidden="true"></i>
    </div>
    <div class="form-group my-4">
      <ng-otp-input [formCtrl]="code" [config]="{ length: 4 }"> </ng-otp-input>

      <div class="mt-4 mb-2" style="text-align: center">
        <span *ngIf="!showResend" style="font-weight: 700">
          {{ "ResetIn" | translate }} {{ minutesToDdayString }}:{{
            secondsToDdayString
          }}
        </span>
      </div>
    </div>
    <div class="text-center">
      <button
        type="button"
        [disabled]="code.value?.length !== 4"
        (click)="verifyCode()"
        class="btn btn-primary width-adjust login-btn mb-3"
      >
        {{ "Verify" | translate }}
      </button>
    </div>
    <p
      class="text-center mb-3 clickable"
      *ngIf="(secondsToDday == 0 || secondsToDday == 1) && minutesToDday == 0"
    >
      <a
        href="#"
        style="color: #0b2027"
        (click)="$event.preventDefault(); resendActivationCode()"
        >{{ "Resend activation code" | translate }}</a
      >
    </p>
  </div>

  <div *ngIf="showForgetPasswordForm" class="mt-4">
    <div class="px-4 d-flex justify-content-between">
      <p class="login-first">
        {{ "did you forget your password?" | translate }}
      </p>
      <i (click)="dismiss()" class="fa fa-times" aria-hidden="true"></i>
    </div>
    <form [formGroup]="forgetPasswordForm" (ngSubmit)="reset()">
      <div class="py-4">
        <div class="webkit-center">
          <div class="form-group width-adjust">
            <app-evento-input
              label="{{ 'Mobile number' | translate }}"
              [eventoFormControl]="forgetPasswordForm.get('mobile')!"
              type="mobile"
              [country]="forgetPasswordForm.value?.mobileRegionCode"
              requiredMessage="{{ 'Required Field' | translate }}"
              validatePhoneNumberMessage="{{
                'Valid Mobile Number' | translate
              }}"
            ></app-evento-input>
          </div>

          <button
            type="submit"
            [disabled]="forgetPasswordForm.invalid"
            class="btn btn-primary width-adjust login-btn mb-3"
          >
            {{ "send" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="showChangePasswordForm" class="mt-4">
    <div class="px-4 d-flex justify-content-between">
      <p class="login-first">
        {{ "change Password" | translate }}
      </p>
      <i (click)="dismiss()" class="fa fa-times" aria-hidden="true"></i>
    </div>
    <form [formGroup]="changePasswordForm">
      <div class="py-4">
        <div class="webkit-center">
          <div class="form-group width-adjust">
            <app-evento-input
              [eventoFormControl]="changePasswordForm.get('password')!"
              type="password"
              requiredMessage="{{ 'Required Field' | translate }}"
              placeholder="{{ 'new password' | translate }}"
            ></app-evento-input>
          </div>
          <div class="form-group width-adjust">
            <app-evento-input
              [eventoFormControl]="changePasswordForm.get('confirmPassword')!"
              type="password"
              requiredMessage="{{ 'Required Field' | translate }}"
              mustMatchMessage="{{ 'Not Matched' | translate }}"
              placeholder="{{ 'Confirm the new password' | translate }}"
            ></app-evento-input>
          </div>
        </div>
      </div>
    </form>
    <div class="text-center">
      <button
        type="button"
        [disabled]="changePasswordForm.invalid"
        (click)="changePassword()"
        class="btn btn-primary width-adjust login-btn mb-3"
      >
        {{ "Save" | translate }}
      </button>
    </div>
  </div>
</div>
